import { render, staticRenderFns } from "./EmailManualSend.vue?vue&type=template&id=bbdb9cc6&"
import script from "./EmailManualSend.js?vue&type=script&lang=js&"
export * from "./EmailManualSend.js?vue&type=script&lang=js&"
import style0 from "./EmailManualSend.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports